import { Component, inject, OnInit, ChangeDetectionStrategy, DOCUMENT, ChangeDetectorRef } from '@angular/core';
import { SupportInfo } from '../../../models/layout/support-model';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../../Services/localization-service';

@Component({
  selector: 'app-support-component',
  imports: [],
  templateUrl: './support-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './support-component.scss'
})
export class SupportComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  private readonly document = inject(DOCUMENT);
  private readonly localizationService = inject(LocalizationService);
  private readonly cdr = inject(ChangeDetectorRef);
  supportInfo: SupportInfo = {
    title: this.translateService.instant('SupportTitle'),
    items: [
      {
        order: 1,
        text: this.translateService.instant('SupportText1')
      },
      {
        order: 2,
        text: this.translateService.instant('SupportText2')
      },
      {
        order: 3,
        text: this.translateService.instant('SupportText3')
      },
    ],
    imageUrl: ''
  }

  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      const canonicalUrl = `${this.document.location.origin}/${lang}/support`;
      this.updateCanonicalUrl(canonicalUrl);
      this.cdr.detectChanges();
    });
  }
  private updateCanonicalUrl(canonicalUrl: string): void {
    let link = this.document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    link.setAttribute('href', canonicalUrl);
  }
}